module.exports = __webpack_public_path__ + "static/media/(H)-12-Capim-Dourado-bijuterias.f9e8a903.jpg";